<ng-container *mojoHasFeatureExtension="directApplicant; else stepper">
  <ng-container *ngTemplateOutlet="isDirectApplicant ? stepper : null">
  </ng-container>
</ng-container>

<ng-template #stepper>
  <ng-container *ngIf="selectedPhaseId$ | async as selectedPhaseId">
    <mojo-stepper
      (stepSelection)="onSelection($event.step.state)"
      [activeValue]="selectedPhaseId"
      [class.expanded-widget]="widget && expandedView"
      [forwardOnly]="moveForwardOnly$ | async"
      [originalStepList]="steps"
      [overwriteColors]="selectedStateCustomColors$ | async"
      [showInactiveLabel]="!widget"
      [showInactiveTooltip]="true"
      [disableStepper]="disableStepper"
      *ngIf="displayedStepsConfiguration$ | async as steps"
      data-cy="dynamic-progress-stepper"
    >
      <ng-container *ngFor="let step of steps; let i= index">
        <cdk-step
          [completed]="wasVisited(step.id) | async"
          [label]="step.label"
          [state]="step"
        >
          <p>here</p>
          <ng-template cdkStepLabel>
            <mat-icon
              [matTooltip]="(selectedStateLabel$ | async)"
              [svgIcon]="step.icon"
              matTooltipPosition="above"
            ></mat-icon>
            <span
              (click)="onSelection(step)"
              [matTooltip]="(selectedStateLabel$ | async)"
              *ngIf="!widget || !expandedView"
              matTooltipPosition="above"
              data-cy="dynamic-stepper-active-label"
            >{{ step.label }}</span>
          </ng-template>
        </cdk-step>
      </ng-container>
    </mojo-stepper>

  </ng-container>
</ng-template>
